module.exports = __webpack_public_path__ + "static/media/icon-krona.7c6d7031.svg";